import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';

export const AFIKIM_ICON: string =
  '/assets/images/route-planning/agencies/Afikim.svg';
export const CARMELIT_ICON: string =
  '/assets/images/route-planning/agencies/Carmelit.svg';
export const DAN_ICON: string =
  '/assets/images/route-planning/agencies/Dan.svg';
export const EGGED_ICON: string =
  '/assets/images/route-planning/agencies/Egged.svg';
export const EGGED_DEREK_ICON: string =
  '/assets/images/route-planning/agencies/DerechEgged.png';
export const KAVIM_ICON: string =
  '/assets/images/route-planning/agencies/Kavim.svg';
export const METROPOLIN_ICON: string =
  '/assets/images/route-planning/agencies/Metropolin.svg';
export const RAHBALIT_ICON: string =
  '/assets/images/route-planning/agencies/CabelExpress.png';
export const KFIR_ICON: string =
  '/assets/images/route-planning/agencies/Kfir.png';
export const TEVEL_ICON: string =
  '/assets/images/route-planning/agencies/Tevel.svg';
export const TRAIN_ICON: string =
  '/assets/images/route-planning/agencies/Train.svg';
export const DAN_BEER_SHEVA_ICON: string =
  '/assets/images/route-planning/agencies/DanBeerSheva.svg';
export const EILOT_ICON: string =
  '/assets/images/route-planning/agencies/eilot.png';
export const EXTRA_ICON: string =
  '/assets/images/route-planning/agencies/Extra.png';
export const EXTRA_JERUSALEM_ICON: string =
  '/assets/images/route-planning/agencies/Extra.png';
export const GALIM_ICON: string =
  '/assets/images/route-planning/agencies/Galim.png';
export const GB_TOURS_ICON: string =
  '/assets/images/route-planning/agencies/GBTours.png';
export const GOLAN_ICON: string =
  '/assets/images/route-planning/agencies/Golan.png';
export const METRO_KAV_TAXI_ICON: string =
  '/assets/images/route-planning/agencies/MetroKavTaxi.png';
export const ODELIA_TAXI_ICON: string =
  '/assets/images/route-planning/agencies/odelia.png';
export const NATIV_EXPRESS_ICON: string =
  '/assets/images/route-planning/agencies/nativ_express.png';
export const SHAM_ICON: string =
  '/assets/images/route-planning/agencies/SHAM.png';
export const SUPER_BUS_ICON: string =
  '/assets/images/route-planning/agencies/SuperBus.png';
export const TNUFA_ICON: string =
  '/assets/images/route-planning/agencies/Tnufa.png';
export const UNITED_TOURS_ICON: string =
  '/assets/images/route-planning/agencies/UnitedTours.png';
export const ES_BUSSES_ICON: string =
  '/assets/images/route-planning/agencies/es-buses.png';
export const ELECTRA_AFIKIM_ICON: string =
  '/assets/images/route-planning/agencies/Afikim.svg';
export const RIDES_AND_TOURS_ICON: string =
  '/assets/images/route-planning/agencies/rides-and-tours.png';
export const DAN_DROM_ICON: string =
  '/assets/images/route-planning/agencies/DanSouth.svg';
export const JERUSALEM_RAMALLAH_UNIFIED_ICON: string =
  '/assets/images/route-planning/agencies/jersalem-ramallah-unified.png';
export const JERUSALEM_ABU_TOR_UNIFIED_ICON: string =
  '/assets/images/route-planning/agencies/jersalem-ramallah-unified.png';
export const JERUSALEM_ALLAWAST_UNIFIED_ICON: string =
  '/assets/images/route-planning/agencies/jersalem-ramallah-unified.png';
export const JERUSALEM_MOUNT_OF_OLIVES_ICON: string =
  '/assets/images/route-planning/agencies/jersalem-ramallah-unified.png';
export const JERUSALEM_SOUTH_UNIFIED_ICON: string =
  '/assets/images/route-planning/agencies/jersalem-ramallah-unified.png';
export const JERUSALEM_SUR_BAHER_UNIFIED_ICON: string =
  '/assets/images/route-planning/agencies/jersalem-ramallah-unified.png';
export const BET_SHEMESH_EXPRESS_ICON: string =
  '/assets/images/route-planning/agencies/BeitshemeshExpress.png';
  export const DAN_NETIVIM_ICON: string =
  '/assets/images/route-planning/agencies/DanNetivim.svg';


export enum eAgency {
  TRAIN = 2,
  EGGED = 3,
  ELECTRA_AFIKIM = 4,
  DAN = 5,
  SHAM = 6,
  RIDES_AND_TOURS = 7,
  GB_TOURS = 8,
  EILOT = 10,
  NATIV_EXPRESS = 14,
  METROPOLIN = 15,
  SUPER_BUS = 16,
  KAVIM = 18,
  CARMELIT = 20,
  KFIR = 21,
  TEVEL = 22,
  GALIM = 23,
  GOLAN = 24,
  AFIKIM = 25,
  DAN_SOUTH = 31,
  DAN_BEER_SHEVA = 32,
  RAHBALIT = 33,
  TNUFA = 34,
  BET_SHEMESH_EXPRESS = 35,
  EXTRA = 37,
  EXTRA_JERUSALEM = 38,
  DAN_NETIVIM = 39,
  UNITED_TOURS = 40,
  JRUSALEM_RAMALLAH_UNIFIED = 42,
  JERUSALEM_ABU_TOR_UNIFIED = 44,
  JERUSALEM_ALLAWAST_UNIFIED = 45,
  JERUSALEM_MOUNT_OF_OLIVES = 47,
  ES_BUSSES = 49,
  JERUSALEM_SOUTH_UNIFIED = 50,
  JERUSALEM_SUR_BAHER_UNIFIED = 51,
  METRO_KAV_TAXI = 91,
  ODELIA_TAXI = 97,
  EGGED_DEREK=135
}

export enum eAgencyNames {
  TRAIN = "רכבת ישראל",
  EGGED = "אגד",
  EGGED_DEREK = "דרך אגד עוטף ירושלים",
  DAN = "דן",
  SHAM = "ש.א.מ",
  RIDES_AND_TOURS = "נסיעות ותיירות",
  GB_TOURS = "גי.בי.טורס",
  EILOT = "מועצה אזורית אילות",
  NATIV_EXPRESS = "נתיב אקספרס",
  METROPOLIN = "מטרופולין",
  SUPERBUS = "סופרבוס",
  KAVIM = "קווים",
  CARMELIT = "כרמלית",
  KFIR = "כפיר",
  TEVEL = "תבל",
  GALIM = "גלים",
  GOLAN = "מועצה אזורית גולן",
  AFIKIM = "אלקטרה אפיקים תחבורה",
  ELECTRA_AFIKIM = "אלקטרה אפיקים",
  DAN_SOUTH = "דן בדרום",
  DAN_BEER_SHEVA = "דן באר שבע",
  RAHBALIT = "כבל אקספרס",
  TNUFA = "תנופה",
  BET_SHEMESH_EXPRESS = "בית שמש אקספרס",
  EXTRA = "אקסטרה",
  EXTRA_JERUSALEM = "אקסטרה ירושלים",
  DAN_NETIVIM = "דן נתיבים בעמ",
  UNITED_TOURS = "יונייטד טורס",
  METRO_KAV_TAXI = "מוניות מטרו קו",
  ODELIA_TAXI = "אודליה מוניות בעמ",
  JRUSALEM_RAMALLAH_UNIFIED = "ירושלים-רמאללה איחוד",
  JERUSALEM_ALLAWAST_UNIFIED = "ירושלים-אלווסט איחוד",
  JERUSALEM_ABU_TOR_UNIFIED = "ירושלים-אבו-תור-ענאתא איחוד",
  JERUSALEM_MOUNT_OF_OLIVES = "ירושלים-הר הזיתים",
  ES_BUSSES = "ירושלים - עיסאוויה מחנה שעפאט איחוד",
  JERUSALEM_SOUTH_UNIFIED = "ירושלים-דרום איחוד",
  JERUSALEM_SUR_BAHER_UNIFIED = "ירושלים-צור באהר איחוד"

}

export const AGENCIES_OPTIONS: SelectOption<eAgency>[] = [
  {
    label: eAgencyNames.TRAIN,
    value: eAgency.TRAIN,
    icon: TRAIN_ICON,
  },
  {
    label: eAgencyNames.EGGED,
    value: eAgency.EGGED,
    icon: EGGED_ICON,
  },
  {
    label: eAgencyNames.EGGED_DEREK,
    value: eAgency.EGGED_DEREK,
    icon: EGGED_DEREK_ICON,
  },
  {
    label: eAgencyNames.DAN,
    value: eAgency.DAN,
    icon: DAN_ICON,
  },
  {
    label: eAgencyNames.SHAM,
    value: eAgency.SHAM,
    icon: SHAM_ICON,
  },
  {
    label: eAgencyNames.RIDES_AND_TOURS,
    value: eAgency.RIDES_AND_TOURS,
    icon: RIDES_AND_TOURS_ICON,
  },
  {
    label: eAgencyNames.GB_TOURS,
    value: eAgency.GB_TOURS,
    icon: GB_TOURS_ICON,
  },
  {
    label: eAgencyNames.EILOT,
    value: eAgency.EILOT,
    icon: EILOT_ICON,
  },
  {
    label: eAgencyNames.NATIV_EXPRESS,
    value: eAgency.NATIV_EXPRESS,
    icon: NATIV_EXPRESS_ICON,
  },
  {
    label: eAgencyNames.METROPOLIN,
    value: eAgency.METROPOLIN,
    icon: METROPOLIN_ICON,
  },
  {
    label: eAgencyNames.SUPERBUS,
    value: eAgency.SUPER_BUS,
    icon: SUPER_BUS_ICON,
  },
  {
    label: eAgencyNames.KAVIM,
    value: eAgency.KAVIM,
    icon: KAVIM_ICON,
  },
  {
    label: eAgencyNames.CARMELIT,
    value: eAgency.CARMELIT,
    icon: CARMELIT_ICON,
  },
  {
    label: eAgencyNames.KFIR,
    value: eAgency.KFIR,
    icon: KFIR_ICON,
  },
  {
    label: eAgencyNames.TEVEL,
    value: eAgency.TEVEL,
    icon: TEVEL_ICON,
  },
  {
    label: eAgencyNames.GALIM,
    value: eAgency.GALIM,
    icon: GALIM_ICON,
  },
  {
    label: eAgencyNames.GOLAN,
    value: eAgency.GOLAN,
    icon: GOLAN_ICON,
  },
  {
    label: eAgencyNames.ELECTRA_AFIKIM,
    value: eAgency.ELECTRA_AFIKIM,
    icon: ELECTRA_AFIKIM_ICON,
  },
  {
    label: eAgencyNames.AFIKIM,
    value: eAgency.AFIKIM,
    icon: AFIKIM_ICON,
  },
  {
    label: eAgencyNames.DAN_SOUTH,
    value: eAgency.DAN_SOUTH,
    icon: DAN_DROM_ICON,
  },
  {
    label: eAgencyNames.DAN_BEER_SHEVA,
    value: eAgency.DAN_BEER_SHEVA,
    icon: DAN_BEER_SHEVA_ICON,
  },
  {
    label: eAgencyNames.RAHBALIT,
    value: eAgency.RAHBALIT,
    icon: RAHBALIT_ICON,
  },
  {
    label: eAgencyNames.TNUFA,
    value: eAgency.TNUFA,
    icon: TNUFA_ICON,
  },
  {
    label: eAgencyNames.BET_SHEMESH_EXPRESS,
    value: eAgency.BET_SHEMESH_EXPRESS,
    icon: BET_SHEMESH_EXPRESS_ICON,
  },
  {
    label: eAgencyNames.EXTRA,
    value: eAgency.EXTRA,
    icon: EXTRA_ICON,
  },
  {
    label: eAgencyNames.EXTRA_JERUSALEM,
    value: eAgency.EXTRA_JERUSALEM,
    icon: EXTRA_ICON,
  },
  {
    label: eAgencyNames.UNITED_TOURS,
    value: eAgency.UNITED_TOURS,
    icon: UNITED_TOURS_ICON,
  },
  {
    label: eAgencyNames.METRO_KAV_TAXI,
    value: eAgency.METRO_KAV_TAXI,
    icon: METRO_KAV_TAXI_ICON,
  },
  {
    label: eAgencyNames.ODELIA_TAXI,
    value: eAgency.ODELIA_TAXI,
    icon: ODELIA_TAXI_ICON,
  },
  {
    label: eAgencyNames.JRUSALEM_RAMALLAH_UNIFIED,
    value: eAgency.JRUSALEM_RAMALLAH_UNIFIED,
    icon: JERUSALEM_RAMALLAH_UNIFIED_ICON,
  },
  {
    label: eAgencyNames.JERUSALEM_ABU_TOR_UNIFIED,
    value: eAgency.JERUSALEM_ABU_TOR_UNIFIED,
    icon: JERUSALEM_ABU_TOR_UNIFIED_ICON,
  },
  {
    label: eAgencyNames.JERUSALEM_ALLAWAST_UNIFIED,
    value: eAgency.JERUSALEM_ALLAWAST_UNIFIED,
    icon: JERUSALEM_ALLAWAST_UNIFIED_ICON,
  },
  {
    label: eAgencyNames.JERUSALEM_MOUNT_OF_OLIVES,
    value: eAgency.JERUSALEM_MOUNT_OF_OLIVES,
    icon: JERUSALEM_MOUNT_OF_OLIVES_ICON,
  },
  {
    label: eAgencyNames.ES_BUSSES,
    value: eAgency.ES_BUSSES,
    icon: ES_BUSSES_ICON,
  },
  {
    label: eAgencyNames.JERUSALEM_SOUTH_UNIFIED,
    value: eAgency.JERUSALEM_SOUTH_UNIFIED,
    icon: JERUSALEM_SOUTH_UNIFIED_ICON,
  },
  {
    label: eAgencyNames.JERUSALEM_SUR_BAHER_UNIFIED,
    value: eAgency.JERUSALEM_SUR_BAHER_UNIFIED,
    icon: JERUSALEM_SUR_BAHER_UNIFIED_ICON,
  },
  {
    label: eAgencyNames.DAN_NETIVIM,
    value: eAgency.DAN_NETIVIM,
    icon: DAN_NETIVIM_ICON,
  },
];
